"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAccountId = void 0;
var buildAccountId = function (_a) {
    var appDefId = _a.appDefId, appInstanceId = _a.appInstanceId;
    return "".concat(appDefId, ":").concat(appInstanceId);
};
exports.buildAccountId = buildAccountId;
//# sourceMappingURL=utils.js.map